import { render, staticRenderFns } from "./change-nickname.vue?vue&type=template&id=5104835f&"
import script from "./change-nickname.vue?vue&type=script&lang=js&"
export * from "./change-nickname.vue?vue&type=script&lang=js&"
import style0 from "./change-nickname.vue?vue&type=style&index=0&id=5104835f&prod&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports